import React, { Component } from 'react'
import ReactSelect from 'react-select'
import { t } from '../../../i18n'
import Modal from '../shared/Modal'
import CustomButton from '../shared/CustomButton'
import InvoiceProductFormContainer from './InvoiceProductFormContainer'
import { ArrowLeftLG, FileDocument, Download, Trash } from '../normalizer'
import { getStatusMeta } from './invoiceStatus'
import { normalizeInvoiceProduct } from './invoiceProducts'
import Moment from 'moment'

// Tolerates every attachment shape seen across the API: a `documents` or
// `attachments` array, or a single `attachment` object — always returns an array.
function getDocuments(invoice) {
  if (Array.isArray(invoice.documents) && invoice.documents.length > 0) return invoice.documents
  if (Array.isArray(invoice.attachments) && invoice.attachments.length > 0) return invoice.attachments
  if (invoice.attachment) return [invoice.attachment]
  return []
}

function getDocumentName(doc, index) {
  if (doc.name) return doc.name
  if (doc.filename) return doc.filename
  if (doc.url) return doc.url.split('/').pop()
  return 'Documento ' + (index + 1)
}

class InvoiceItem extends Component {
  state = {
    createModal: false,
    editHeaderModal: false,
    removeModal: false,
    product: null,
    // Header edit form values — populated when the modal opens
    editNumber: '',
    editDate: '',
    editSaleType: null,
  }

  showCreationModal   = () => this.setState({ createModal: true })
  showRemoveModal     = (product) => this.setState({ removeModal: true, product })
  showEditHeaderModal = () => {
    const { invoice, saleTypes } = this.props
    this.setState({
      editHeaderModal: true,
      editNumber: invoice.invoice_number || '',
      editDate: invoice.invoice_date ? invoice.invoice_date.slice(0, 10) : '',
      editSaleType: saleTypes.find(function(s) { return s.name === invoice.sale_type }) || null,
    })
  }
  untoggling = (name) => () => this.setState({ [name]: false, product: null })

  handleProductCreation = (data) => {
    this.props.onProductCreation(data)
    this.setState({ createModal: false })
  }

  handleProductRemove = () => {
    this.props.onProductRemove(this.state.product)
    this.setState({ removeModal: false, product: null })
  }

  handleHeaderSave = () => {
    const { editNumber, editDate, editSaleType } = this.state
    this.props.onHeaderEdit({ number: editNumber, invoiceDate: editDate, saleType: editSaleType, document: {} })
    this.setState({ editHeaderModal: false })
  }

  render() {
    const { campaign, linking, editable, invoice, products, saleTypes, headerErrors } = this.props
    const { createModal, editHeaderModal, removeModal, editNumber, editDate, editSaleType } = this.state

    const statusMeta = getStatusMeta(invoice)
    
    const reason = invoice.reprove_reason ? invoice.reprove_reason.name : null
    const documents = getDocuments(invoice)

    return (
      <div className="invoice-form-page">
        <CustomButton link tight to={linking} className="invoice-form-back">
          <ArrowLeftLG className="invoice-form-back-icon" />
          Voltar
        </CustomButton>
        <h1 className="invoice-form-title">Detalhes da fatura</h1>

        {/* ── Invoice information panel ── */}
        <div className="invoice-form-card">
          <div className="invoice-form-row">
            <div className="invoice-form-field">
              <span className="invoice-form-label">Nº Fatura</span>
              <span>{invoice.invoice_number || '-'}</span>
            </div>
            <div className="invoice-form-field">
              <span className="invoice-form-label">Data</span>
              <span>{invoice.invoice_date ? new Moment(invoice.invoice_date).format(t('date-format')) : '-'}</span>
            </div>
            <div className="invoice-form-field">
              <span className="invoice-form-label">Data de Registo</span>
              <span>{invoice.created_at ? new Moment(invoice.created_at).format(t('date-format')) : '-'}</span>
            </div>
            <div className="invoice-form-field">
              <span className="invoice-form-label">Tipo de Venda</span>
              <span>{invoice.sale_type || '-'}</span>
            </div>
            <div className="invoice-form-field">
              <span className="invoice-form-label">Estado</span>
              {statusMeta ? (
                <span className={'invoice-state-pill invoice-state-pill--' + statusMeta.tone}>{statusMeta.label}</span>
              ) : (
                <span>-</span>
              )}
            </div>
            <div className="invoice-form-field">
              <span className="invoice-form-label">Motivo</span>
              <span>{reason || '-'}</span>
            </div>
          </div>
          {editable && (
            <button className="gl-button secondary medium body-m" type="button" onClick={this.showEditHeaderModal}>
              Editar cabeçalho
            </button>
          )}
        </div>

        {/* ── Documents section ── */}
        <div className="invoice-form-section">
          <h5 className="invoice-form-section-title">Documentos</h5>
          {documents.length > 0 ? (
            <div className="invoice-documents-list">
              {documents.map(function(doc, i) {
                return (
                  <div key={"doc-" + i} className="document-card">
                    <div className="document-card-icon-container">
                      <div className="document-card-icon">
                        <FileDocument />
                      </div>
                    </div>
                    <div className="document-card-container">
                      <div className="document-card-title">
                        {getDocumentName(doc, i)}
                      </div>
                      <button
                        type="button"
                        className="document-card-download"
                        onClick={function() {
                          window.open(doc.url, "_blank");
                        }.bind(this)}
                      >
                        <Download />
                        Descarregar
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="invoice-form-card">
              <div className="invoice-documents-empty">Sem documentos</div>
            </div>
          )}
        </div>

        {/* ── Products section ── */}
        <div className="invoice-form-section">
          <h5 className="invoice-form-section-title">Produtos</h5>
          {products.length > 0 ? (
            <div className="invoice-form-products">
              <div className="invoice-form-table-panel">
                <table className="w-full invoice__table">
                  <thead>
                    <tr className="invoice__table-header">
                      <th className="data-table__header invoice__header">Marca</th>
                      <th className="data-table__header invoice__header">Grupo</th>
                      <th className="data-table__header invoice__header">Categoria</th>
                      <th className="data-table__header invoice__header">Código do Produto</th>
                      <th className="data-table__header invoice__header data-table__header--right">Qtd</th>
                      {editable && (
                        <th className="data-table__header invoice__header data-table__header--center">Ações</th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {products.map(function(p, i) {
                      var row = normalizeInvoiceProduct(p)
                      return (
                        <tr key={'prod-' + i} className="invoice__table-row">
                          <td className="invoice__cell">{row.brand || '-'}</td>
                          <td className="invoice__cell">{row.group || '-'}</td>
                          <td className="invoice__cell">{row.category || '-'}</td>
                          <td className="invoice__cell">{row.productCode || '-'}</td>
                          <td className="invoice__cell invoice__cell--right">{row.quantity}</td>
                          {editable && (
                            <td className="invoice__cell invoice__cell--center">
                              <div className="invoice__actions">
                                <button
                                  type="button"
                                  className="invoice__action invoice__action--danger"
                                  title="Eliminar"
                                  onClick={function() { this.showRemoveModal(p) }.bind(this)}
                                >
                                  <Trash className="invoice__action-icon" />
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      )
                    }.bind(this))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="invoice-form-card">
              <div className="invoice-documents-empty">Sem produtos</div>
            </div>
          )}
        </div>

        {/* ── Submit to validation ── */}
        {editable && products.length > 0 && (
          <div className="invoice-form-actions">
            <button className="gl-button primary medium body-m" type="button" onClick={this.props.onSubmitToValidation}>
              Enviar para aprovação
            </button>
          </div>
        )}

        {/* ── Add product modal ── */}
        {editable && (
          <Modal large untoggle={this.untoggling('createModal')} show={createModal}>
            <InvoiceProductFormContainer createMode onCancel={this.untoggling('createModal')} onSubmit={this.handleProductCreation} campaign={campaign} />
          </Modal>
        )}

        {/* ── Remove product confirm modal ── */}
        {editable && (
          <Modal small untoggle={this.untoggling('removeModal')} show={removeModal}>
            <div className="gl2026-modal__header">
              <h4 className="gl2026-modal__title">Remover produto?</h4>
            </div>
            <div className="gl2026-modal__footer">
              <CustomButton secondary type="button" onClick={this.untoggling('removeModal')}>Não</CustomButton>
              <CustomButton type="button" onClick={this.handleProductRemove}>Sim</CustomButton>
            </div>
          </Modal>
        )}

        {/* ── Edit header modal ── */}
        {editable && (
          <Modal untoggle={this.untoggling('editHeaderModal')} show={editHeaderModal}>
            <div className="gl2026-modal__header">
              <h4 className="gl2026-modal__title">Editar Cabeçalho</h4>
              <button className="gl2026-modal__close" type="button" onClick={this.untoggling('editHeaderModal')}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12" /></svg>
              </button>
            </div>
            <div className="invoice-product-form">
              <div className="invoice-product-form-grid">
                <div className="invoice-product-form-field">
                  <label className="invoice-form-label">Nº Fatura</label>
                  <input className="invoice-form-input" value={editNumber} onChange={function(e) { this.setState({ editNumber: e.target.value }) }.bind(this)} />
                </div>
                <div className="invoice-product-form-field">
                  <label className="invoice-form-label">Data</label>
                  <input type="date" className="invoice-form-input" value={editDate} onChange={function(e) { this.setState({ editDate: e.target.value }) }.bind(this)} />
                </div>
                <div className="invoice-product-form-field">
                  <label className="invoice-form-label">Tipo de Venda</label>
                  <ReactSelect
                    options={saleTypes}
                    value={editSaleType}
                    onChange={function(st) { this.setState({ editSaleType: st }) }.bind(this)}
                    getOptionLabel={function(o) { return o.name }}
                    getOptionValue={function(o) { return o.id }}
                    placeholder="Selecione"
                    classNamePrefix="invoice-select"
                  />
                </div>
              </div>
              {headerErrors && Object.keys(headerErrors).length > 0 && (
                <div className="gl2026-modal__alert">Erro ao guardar alterações.</div>
              )}
            </div>
            <div className="invoice-product-form-footer">
              <button className="gl-button secondary medium body-m" type="button" onClick={this.untoggling('editHeaderModal')}>Cancelar</button>
              <button className="gl-button primary medium body-m" type="button" onClick={this.handleHeaderSave}>Guardar</button>
            </div>
          </Modal>
        )}
      </div>
    )
  }
}

export default InvoiceItem
